import { getEnvironmentName } from '@hc-frontend/business'
import {
  initSnowplowTracker,
  localStorageHcSessionDataProvider,
  hcSessionContextProvider,
  localStorageAnonymizedPiiDataProvider,
  anonymizedPiiContextProvider,
  ResponseSnowPlow
} from '@hc-frontend/third-party-snowplow'
import { localStoragePHChannelProvider } from 'utils/snowplow/context/ph-channel/localStorageDataProvider'
import { phChannelContextProvider } from 'utils/snowplow/context/ph-channel/phChannelContextGenerators'
import { localStorageFunnelProvider } from 'utils/snowplow/context/funnel-context/localStorageDataProvider'
import { funnelContextProvider } from 'utils/snowplow/context/funnel-context/funnelContextGenerators'

function initSnowplow(): ResponseSnowPlow {
  return initSnowplowTracker({
    isProd: getEnvironmentName() === 'PROD',
    contexts: [
      hcSessionContextProvider(localStorageHcSessionDataProvider),
      anonymizedPiiContextProvider(localStorageAnonymizedPiiDataProvider),
      phChannelContextProvider(localStoragePHChannelProvider),
      funnelContextProvider(localStorageFunnelProvider)
    ]
  })
}

export default initSnowplow
